"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CouponSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.14076989,12.8437561 C4.94766084,12.6506471 4.94766084,12.3375554 5.14076989,12.1444464 L5.14111503,12.1441016 L12.1469617,5.15206535 C12.3405079,4.95890071 12.6539513,4.95905534 12.8473068,5.15241083 C13.0404159,5.34551988 13.0404159,5.6586115 12.8473068,5.85172055 L5.84111503,12.8441016 C5.64756886,13.0372662 5.33412538,13.0371116 5.14076989,12.8437561 Z M12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 Z M12,13 C10.8954305,13 10,12.1045695 10,11 C10,9.8954305 10.8954305,9 12,9 C13.1045695,9 14,9.8954305 14,11 C14,12.1045695 13.1045695,13 12,13 Z M6,8 C6.55228475,8 7,7.55228475 7,7 C7,6.44771525 6.55228475,6 6,6 C5.44771525,6 5,6.44771525 5,7 C5,7.55228475 5.44771525,8 6,8 Z M6,9 C4.8954305,9 4,8.1045695 4,7 C4,5.8954305 4.8954305,5 6,5 C7.1045695,5 8,5.8954305 8,7 C8,8.1045695 7.1045695,9 6,9 Z" })));
};
CouponSmall.displayName = 'CouponSmall';
exports.default = CouponSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CouponSmall.js.map